export function CheckboxGroup({ selected, setSelected, details, setDetails }) {
  const options = [
    {
      label: "Showroom",
      name: "showroom",
      iconClass: "fas fa-store", // Représente bien un showroom / magasin
    },
    {
      label: "Essai véhicule",
      name: "essaie_vehicule",
      iconClass: "fas fa-road", // Idéal pour illustrer l’idée d’un essai routier
    },
    {
      label: "Entretien",
      name: "entretien",
      iconClass: "fas fa-tools", // Évoque bien l’entretien mécanique général
    },
    {
      label: "Assistance",
      name: "assistance",
      iconClass: "fas fa-user-cog", // Très parlant pour l’assistance ou le support
    },
    {
      label: "Autres",
      name: "autres",
      iconClass: "fas fa-ellipsis-h",
      input: "Précisez l’intervention souhaitée",
    },
  ];

  const toggle = (name) => {
    if (selected.includes(name)) {
      setSelected((prev) => prev.filter((n) => n !== name));
      setDetails((prev) => {
        const newDetails = { ...prev };
        delete newDetails[name];
        return newDetails;
      });
    } else {
      setSelected((prev) => [...prev, name]);
    }
  };

  const handleInputChange = (name, value) => {
    setDetails((prev) => ({ ...prev, [name]: value }));
  };

  return (
    <div className="flex flex-wrap justify-center gap-4">
      {options.map((opt) => (
        <div key={opt.name} className="flex flex-col items-center w-35">
          <button
            type="button"
            onClick={() => toggle(opt.name)}
            className={`w-25 h-25 rounded-full flex items-center justify-center text-4xl border-2 transition
            ${
              selected.includes(opt.name)
                ? "bg-green-600 text-white border-green-600"
                : "border-gray-300 text-white hover:border-green-500 hover:text-green-500"
            }
          `}
          >
            <i className={opt.iconClass}></i>
          </button>
          <span className="mt-2 text-10 text-center uppercase font-semibold">
            {opt.label}
          </span>

          {selected.includes(opt.name) && opt.input && (
            <input
              type="text"
              placeholder={opt.input}
              value={details[opt.name] || ""}
              onChange={(e) => handleInputChange(opt.name, e.target.value)}
              className="mt-2 w-full border p-2 rounded text-sm"
            />
          )}
        </div>
      ))}
    </div>
  );
}
